import {createStructuredSelector} from 'reselect';
import {bindActionCreators} from 'redux';
// selectors
import {isDirty} from '~/selectors/DesignSelectors';
import {prompt} from '~/actions/NotificationActions';
import {selectCartItems, selectCartSubTotal} from '~/api/designs/cartApi';
import {
  selectAlreadyAddedCartItems,
  selectRecentlyAddedCartItems
} from '~/slices/cartSlice';

export function select() {
  return createStructuredSelector({
    alreadyAddedItems: selectAlreadyAddedCartItems,
    isDesignDirty: isDirty,
    cartItems: selectCartItems,
    recentlyAddedItems: selectRecentlyAddedCartItems,
    subTotal: selectCartSubTotal
  });
}

export const actions = dispatch =>
  bindActionCreators(
    {
      prompt
    },
    dispatch
  );
